import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-m-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  for: "type",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: _ctx.parameters,
      class: "p-datatable-sm kn-table p-m-2",
      dataKey: "name",
      responsiveLayout: "stack",
      breakpoint: "600px",
      onRowClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('parameterSelected', $event.data)))
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.olapCrossNavigationDefinitionDialogDescriptor.columns, (column, index) => {
          return (_openBlock(), _createBlock(_component_Column, {
            class: "kn-truncated",
            key: index,
            field: column.field,
            header: _ctx.$t(column.label),
            sortable: true
          }, null, 8, ["field", "header"]))
        }), 128)),
        _createVNode(_component_Column, {
          style: _ctx.olapCrossNavigationDefinitionDialogDescriptor.iconColumn.style
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.deleteParameterConfirm(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.delete'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value"]),
    (_ctx.addNewParameterVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('documentExecution.olap.crossNavigationDefinition.crossNavigationType')), 1),
          _createVNode(_component_Dropdown, {
            id: "type",
            class: "kn-material-input",
            modelValue: _ctx.selectedParameter.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedParameter.type = $event)),
            options: _ctx.olapCrossNavigationDefinitionDialogDescriptor.typeList,
            optionLabel: "label",
            optionValue: "value"
          }, null, 8, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true)
  ]))
}